import axios from './common';

export const signIn = async credentials => {
  const response = await axios.post('/api/auth/signin', credentials);
  return response.data;
};
